// OPTIMIZELY EVENTS - SKIP PRODUCT PAGE
export const OPTIMIZELY_PAGEVIEW_ABOUT_YOU_EVENT = 'pageview-cover-journey-about-you';
export const OPTIMIZELY_PAGEVIEW_ABOUT_YOUR_HOME_EVENT = 'pageview-cover-journey-about-your-home';
export const OPTIMIZELY_PAGEVIEW_APPLICATION_BANK_ACCOUNT_EVENT =
  'pageview-cover-policy-application-bank-account';
export const OPTIMIZELY_PAGEVIEW_APPLICATION_CONFIRMATION_EVENT =
  'pageview-cover-journey-application-confirmation';
export const OPTIMIZELY_PAGEVIEW_APPLICATION_DETAILS_EVENT =
  'pageview-cover-policy-application-details';
export const OPTIMIZELY_PAGEVIEW_BOILER_COVER_EVENT = 'pageview-boiler-cover';
export const FUNNEL_ENTRY = 'funnel-entry';

export const optimizelyPageviewPlanInfoEventMap = {
  Essentials: 'pageview-boiler-cover-Essentials',
  Starter: 'pageview-boiler-cover-Starter',
  Complete: 'pageview-boiler-cover-Complete',
  Advanced: 'pageview-boiler-cover-Advanced',
};

export const optimizelyFeatureFlags = {
  ADDRESS_SEARCH: 'address-search',
  QUOTE_PLATFORM_ROLLOUT: 'quote-platform-rollout',
  GIFT_FLAG_OFFER: 'gift-flag-offer',
  NEW_SALES_JOURNEY: 'new-sales-journey',
  GNATTA_WEB_CHAT: 'gnattawebchat',
  SHOW_ABS: 'show-abs',
  SHOW_TRUSTPILOT_RATING_COMPARISON: 'trustpilot_comparison_ratings',
  ALLOW_ABS_FUNNEL: 'allow-abs-funnel',
  QUOTES_BFF_ROLLOUT: 'quotes-bff-rollout',
  REMOVE_TAPS_AND_TOILETS: 'remove-taps-and-toilets',
  SALES_TRACKING: 'sales-tracking',
  HIDE_50_POUND_EXCESS_MESSAGING: 'hide-50-pound-excess-messaging',
  ENABLE_INSURANCE_EMBER_FUNNEL: 'corgi-insurance-ember-funnel',
} as const;
